import { apiFetch } from "@/integrations/backend/client";

export type DashboardPointsSeriesItem = {
  workout_assigned_id: string;
  date: string | null; // YYYY-MM-DD
  points: number;
};

export type DashboardLoadRatioSeriesItem = {
  date: string; // YYYY-MM-DD
  label: string;
  value: number;
  is_future?: boolean;
};

export type DashboardMetrics = {
  total_points: number;
  total_logged_workouts: number;
  points_series: DashboardPointsSeriesItem[];
  load_ratio_series: DashboardLoadRatioSeriesItem[];
  load_ratio_week_start: string | null;
};

export type DashboardMetricsParams = {
  limit?: number;
  from_date?: string; // YYYY-MM-DD
  to_date?: string; // YYYY-MM-DD
};

function buildQuery(params?: DashboardMetricsParams): string {
  if (!params) return "";
  const qs = new URLSearchParams();
  if (params.limit != null) qs.set("limit", String(params.limit));
  if (params.from_date) qs.set("from_date", params.from_date);
  if (params.to_date) qs.set("to_date", params.to_date);
  const s = qs.toString();
  return s ? `?${s}` : "";
}

export async function fetchDashboardMetrics(params?: DashboardMetricsParams): Promise<DashboardMetrics> {
  const res = await apiFetch(`/api/v1/dashboard/metrics${buildQuery(params)}`, { method: "GET" });
  if (!res.ok) throw new Error(`dashboard_metrics_failed:${res.status}`);
  return (await res.json()) as DashboardMetrics;
}

/**
 * Fire-and-forget: triggers backend to ensure plan PDF is generated for the
 * current user if generated_plan_pdf is False. Runs asynchronously; does not
 * block or throw.
 */
export function ensurePlanPdf(): void {
  apiFetch("/api/v1/dashboard/ensure-plan-pdf", { method: "GET" }).catch(() => {
    // Silently ignore; this is a background task
  });
}

